import { RneComponent } from './pages/rne/rne';
import { Routes } from '@angular/router';
import { LinesManagementComponent } from './pages/lines-management/lines-management.component';

export const routes: Routes = [
  {
    path: 'embed/lines',
    component: LinesManagementComponent,
    data: { view: 'legacy' },
  },
  {
    path: 'embed/lines-v2',
    component: LinesManagementComponent,
    data: { view: 'all' },
  },
  {
    path: 'embed/mi-parche',
    component: LinesManagementComponent,
    data: { view: 'mi-parche' },
  },
  {
    path: 'embed/lines/edit/:id',
    loadComponent: () =>
      import('./pages/lines-management/line-edit/line-edit.component').then(
        (m) => m.LineEditComponent
      ),
  },
  {
    path: 'embed/lines/:msisdn/fnf-details',
    loadComponent: () =>
      import('./pages/lines-management/fnf-details/fnf-details').then((m) => m.FnfDetails),
    data: { view: 'legacy' },
  },
  {
    path: 'embed/lines-v2/:msisdn/fnf-details',
    loadComponent: () =>
      import('./pages/lines-management/fnf-details/fnf-details').then((m) => m.FnfDetails),
    data: { view: 'all' },
  },
  {
    path: 'embed/mi-parche/:msisdn/fnf-details',
    loadComponent: () =>
      import('./pages/lines-management/fnf-details/fnf-details').then((m) => m.FnfDetails),
    data: { view: 'mi-parche' },
  },
  {
    path: 'embed/user-historical',
    loadComponent: () =>
      import('./pages/user-historical/user-historical').then((m) => m.UserHistorical),
  },
  {
    path: 'embed/user-resources',
    loadComponent: () =>
      import('./pages/user-resources/user-resources').then((m) => m.UserResources),
  },
  {
    path: 'embed/sim-activation',
    loadComponent: () =>
      import('./pages/sim-activation/sim-activation').then((m) => m.SimActivation),
  },
  {
    path: 'embed/sim-replacement',
    loadComponent: () => import('./pages/sim-repo/sim-repo').then((m) => m.SimRepo),
  },
  {
    path: 'embed/create-pqr',
    loadComponent: () => import('./pages/user-pqr/create-pqr/create-pqr').then((m) => m.CreatePqr),
  },
  {
    path: 'embed/search-pqr',
    loadComponent: () => import('./pages/user-pqr/search-pqr/search-pqr').then((m) => m.SearchPqr),
  },
  {
    path: 'embed/imei-check',
    loadComponent: () =>
      import('./pages/my-devices/imei-check/imei-check').then((m) => m.ImeiCheck),
  },
  {
    path: 'embed/register-device',
    loadComponent: () =>
      import('./pages/my-devices/register-device/register-device').then((m) => m.RegisterDevice),
  },
  {
    path: 'embed/blocked-devices',
    loadComponent: () =>
      import('./pages/my-devices/blocked-devices/blocked-devices').then((m) => m.BlockedDevices),
  },
  {
    path: 'embed/unblock-device',
    loadComponent: () =>
      import('./pages/my-devices/unblock-device/unblock-device').then((m) => m.UnblockDevice),
  },
  {
    path: 'embed/block-device',
    loadComponent: () =>
      import('./pages/my-devices/block-device/block-device').then((m) => m.BlockDevice),
  },
  {
    path: 'embed/registered-devices',
    loadComponent: () =>
      import('./pages/my-devices/registered-devices/registered-devices').then(
        (m) => m.RegisteredDevices
      ),
  },
  {
    path: 'embed/enter-pqr',
    loadComponent: () => import('./pages/pqr/enter-pqr/enter-pqr').then((m) => m.EnterPqr),
  },
  {
    path: 'embed/find-pqr',
    loadComponent: () => import('./pages/pqr/find-pqr/find-pqr').then((m) => m.FindPqr),
  },
  {
    path: 'embed/new-portability',
    loadComponent: () =>
      import('./pages/portability/new-portability/new-portability').then((m) => m.NewPortability),
  },
  {
    path: 'embed/my-portabilities',
    loadComponent: () =>
      import('./pages/portability/my-portabilities/my-portabilities').then(
        (m) => m.MyPortabilitiesComponent
      ),
  },
  {
    path: 'embed/my-portabilities/:id',
    loadComponent: () =>
      import('./pages/portability/my-portabilities/my-portabilities').then(
        (m) => m.MyPortabilitiesComponent
      ),
  },
  {
    path: 'embed/user-cards',
    loadComponent: () => import('./pages/user-cards/user-cards').then((m) => m.UserCards),
  },
  {
    path: 'embed/contact-us',
    loadComponent: () => import('./pages/contact-us/contact-us').then((m) => m.ContactUs),
  },
  {
    path: 'embed/faq',
    loadComponent: () => import('./pages/faq/faq').then((m) => m.Faq),
  },
  {
    path: 'embed/automatic-debit',
    loadComponent: () =>
      import('./pages/automatic-debit/automatic-debit').then((m) => m.AutomaticDebit),
  },
  {
    path: 'embed/excluded-numbers',
    loadComponent: () => import('./pages/rne/rne').then((m) => m.RneComponent),
  },
  {
    path: '',
    redirectTo: 'embed/lines',
    pathMatch: 'full',
  },
];
